/**
 * Format a date string to a human-readable format
 */
export function formatDate(dateString?: string): string {
  if (!dateString) {
    return 'Unknown';
  }

  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return dateFormatter.format(new Date(dateString));
}
